var _style, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_b2T7{animation:spinner_xe7Q .8s linear infinite}.spinner_YRVV{animation-delay:-.65s}.spinner_c9oY{animation-delay:-.5s}@keyframes spinner_xe7Q{93.75%,100%{r:3px}46.875%{r:.2px}}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_b2T7",
    cx: 4,
    cy: 12,
    r: 3,
    stroke: "#eee",
    fill: "#eee"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_b2T7 spinner_YRVV",
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "#eee",
    fill: "#eee"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_b2T7 spinner_c9oY",
    cx: 20,
    cy: 12,
    r: 3,
    stroke: "#eee",
    fill: "#eee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e73c9cdd095a222d4b86c886a59273af.svg";
export { ForwardRef as ReactComponent };